import { j as a, c as o } from "./utils-BdNIfrGQ.js";
import { T as r } from "./Text-BhLXzYEf.js";
import * as u from "react";
import { P as f } from "./index-oiSd2zY3.js";
import { c as b } from "./index-Di82Y7n3.js";
var p = "Label", n = u.forwardRef((t, s) => /* @__PURE__ */ a.jsx(
  f.label,
  {
    ...t,
    ref: s,
    onMouseDown: (e) => {
      e.target.closest("button, input, select, textarea") || (t.onMouseDown?.(e), !e.defaultPrevented && e.detail > 1 && e.preventDefault());
    }
  }
));
n.displayName = p;
var x = n;
function g({
  className: t,
  ...s
}) {
  return /* @__PURE__ */ a.jsx(
    x,
    {
      "data-slot": "label",
      className: o(
        "flex gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        t
      ),
      ...s
    }
  );
}
const j = b("[&>span:first-child]:leading-none", {
  variants: {
    variant: {
      visible: "flex flex-col mb-4",
      hidden: "hidden",
      inline: "mb-0 text-nowrap mr-4"
    }
  },
  defaultVariants: {
    variant: "visible"
  }
}), v = () => /* @__PURE__ */ a.jsx("span", { className: "ml-2", children: /* @__PURE__ */ a.jsx(r, { color: "destructive", title: "required", fontWeight: "semibold", children: "*" }) }), L = ({
  children: t,
  htmlFor: s,
  helperText: e,
  required: i,
  variant: l,
  fontWeight: d = "body",
  labelSize: c = "sm",
  ...m
}) => /* @__PURE__ */ a.jsxs(g, { className: o(j({ variant: l })), ...m, htmlFor: s, children: [
  /* @__PURE__ */ a.jsxs(r, { size: c, fontWeight: d, children: [
    t,
    i && /* @__PURE__ */ a.jsx(v, {})
  ] }),
  typeof e == "string" && /* @__PURE__ */ a.jsx(r, { size: "sm", color: "muted", children: e }),
  typeof e != "string" && e
] });
export {
  L,
  v as R
};
